import { useDisclosure } from '@ds';
import { isNil, noop } from 'lodash-es';
import { RandomizationResultsModal } from './RandomizationResultsModal';
import { randomizationTypeNames } from '@/constants/case/case.constants';
import { OrganType, Randomization } from '@/api/apis/case';

type RandomizationResultsButtonProps = {
  randomization: Randomization | null | undefined;
  txCenterName?: string;
  organ: OrganType;
};

export const RandomizationResultsButton = ({ randomization, txCenterName, organ }: RandomizationResultsButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (isNil(randomization)) return null;

  return (
    <>
      <div tabIndex={0} onKeyDown={noop} role="button" onClick={onOpen} className="text-m-m underline truncate">
        {randomizationTypeNames[randomization.result]}
      </div>
      {isOpen && (
        <RandomizationResultsModal
          onClose={onClose}
          txCenterName={txCenterName}
          organType={organ}
          randomization={randomization}
        />
      )}
    </>
  );
};
